import React from "react";
import tw from "twin.macro";

const Section = tw.div`flex relative w-full flex-col h-full items-center justify-center xl:hidden px-4`;
const Title = tw.p`text-white font-mazuis italic text-4xl md:text-5xl z-20 text-center`;
const CTA = tw.p`text-primary font-gothic uppercase text-lg md:text-xl absolute bottom-0 right-0 m-4 z-20 duration-500 ease-in-out`;
const Shadow = tw.div`absolute top-0 left-0 w-full h-full from-primary to-dark bg-gradient-to-br z-10 opacity-0 duration-500 ease-in-out`;

const SixthMan = ({ ...rest }) => {
  return (
    <Section {...rest}>
      <Shadow className="team-shadow" />
      <Title>Why Hire Us?</Title>
      <CTA className="team-cta">Find Out!</CTA>
    </Section>
  );
};

export default SixthMan;
